import { useContext, useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { MediaQueryEnum, useMediaQuery } from 'commons/utils';
import { useGetAuditions } from 'hooks/u005/useGetAuditionHooks';
import { AuditionTitle } from 'organisms/AuditionTitle';
import { AuditionMessageSection } from 'organisms/u005/AuditionMessageSection';
import { InfoSection } from 'organisms/u005/InfoSection';
import { MessageSection } from 'organisms/u005/MessageSection';
import { AppContext } from 'templates/AppContextProvider';
import { AppFooter } from 'templates/AppFooter';
import { AppHeader } from 'templates/AppHeader';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { TransitionButton } from 'atoms/TransitionButton';
import LoadingModal from 'organisms/LoadingModal';
import { GroupAuditionInfo } from './U005/GroupAuditionInfo';
import { useParams } from 'react-router-dom';
import { NotFound } from './404';

export const AuditionInfo = () => {
  const ctx = useContext(AppContext);
  const userId = ctx.userId;
  const routeParams = useParams();
  const { audition_id: auditionId } = routeParams;
  console.log({ auditionId }, { userId });
  const { t: tMessage } = useTranslationWithLang('message');
  const isSp = useMediaQuery(MediaQueryEnum.sp);
  const [auditionTitle, setAuditionTitle] = useState<string>('');
  const [audition, loading, err] = useGetAuditions(userId, auditionId ?? '');
  const { t: tAuditionInfo } = useTranslationWithLang('auditionInfo');

  useEffect(() => {
    if (err != null) setAuditionTitle(tMessage('MU005F0043I'));
    if (audition != null) {
      ctx.setSelectedAuditionTitle(audition.audition_info.title);
      if (
        audition?.audition_info.decline_kbn === '3' ||
        audition?.audition_info.decline_kbn === '5'
      ) {
        setAuditionTitle(tMessage('MU005F0043I'));
      } else {
        setAuditionTitle(audition.audition_info.title);
      }
    }
  }, [audition, err, tMessage, ctx]);
  useEffect(() => {
    console.log('Audition data:', audition);
    console.log('Loading state:', loading);
    console.log('Error state:', err);
  }, [audition, loading, err]);

  if (!auditionId) {
    return <NotFound />;
  }
  if (loading) {
    return <LoadingModal />;
  }

  // モバイル表示
  if (isSp) {
    return (
      <>
        <AppHeader />
        <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
          {auditionTitle}
        </div>
        <div className="w-full h-full mx-auto pt-10 px-5 text-[--c-text] bg-[--c-bg] mt-10">
          <AuditionTitle title={auditionTitle} withTopLink={err != null}></AuditionTitle>
          <div className="px-4">
            {err == null &&
              audition != null &&
              audition.audition_info.decline_kbn !== '3' &&
              audition.audition_info.decline_kbn !== '5' &&
              (ctx.isGlobal &&
              audition.group?.[0]?.applied === undefined &&
              audition.group?.[0]?.group_ap === '1' ? (
                <GroupAuditionInfo audition={audition} />
              ) : (
                <>
                  <div className="w-full max-w-[720px] mt-5 mb-0 mx-auto">
                    <InfoSection auditionId={auditionId}></InfoSection>
                  </div>
                  <Stack
                    gap={2.5}
                    direction="column"
                    className="w-full max-w-[960px] mt-5 mb-0 mx-auto"
                  >
                    <AuditionMessageSection
                      userId={userId}
                      auditionId={auditionId}
                      audition={audition}
                      loading={loading}
                      specific_use={audition.specific_use}
                      privacy_notice={audition.privacy_notice}
                      audition_terms={audition.audition_terms}
                      now_dtm={audition.now_dtm}
                      declineKbn={audition.audition_info.decline_kbn}
                      examination_no={audition.examination_info.examination_no}
                      examination_kbn={audition.examination_info.examination_kbn}
                      examination_s_no={audition.examination_info.examination_s_no}
                      result={audition.examination_info.result}
                    ></AuditionMessageSection>
                    <MessageSection userId={userId} auditionId={auditionId}></MessageSection>
                  </Stack>
                </>
              ))}
            <div className="flex justify-center items-center">
              <TransitionButton className="w-[10rem]" />
            </div>
          </div>
        </div>
        <AppFooter />
      </>
    );
  }

  return (
    <>
      <div className="mx-auto h-screen" style={{ background: 'var(--c-background)' }}>
        <div className="min-h-screen mx-auto flex flex-col">
          <AppHeader />
          <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
            {tAuditionInfo('TU005_001')}
          </div>
          <main className="flex-1 flex flex-col justify-between items-center pt-40 pb-20 overflow-y-auto">
            <div className="flex w-full justify-center items-center bg-[--c-background2] min-h-[6rem]">
              <AuditionTitle title={auditionTitle} withTopLink={err != null}></AuditionTitle>
            </div>
            {err == null &&
              audition != null &&
              audition.audition_info.decline_kbn !== '3' &&
              audition.audition_info.decline_kbn !== '5' &&
              (ctx.isGlobal &&
              audition.group?.[0]?.applied === undefined &&
              audition.group?.[0]?.group_ap === '1' ? (
                <GroupAuditionInfo audition={audition} />
              ) : (
                <div className="w-[70%] flex flex-col flex-grow justify-evenly">
                  <div className="flex justify-center items-center w-full h-[15rem] my-4">
                    <InfoSection auditionId={auditionId}></InfoSection>
                  </div>
                  <div className="flex items-center w-full h-[15rem] mb-8">
                    <div className="flex-1 h-full mr-4 max-w-[50%]">
                      <AuditionMessageSection
                        userId={userId}
                        auditionId={auditionId}
                        audition={audition}
                        loading={loading}
                        specific_use={audition.specific_use}
                        privacy_notice={audition.privacy_notice}
                        audition_terms={audition.audition_terms}
                        now_dtm={audition.now_dtm}
                        declineKbn={audition.audition_info.decline_kbn}
                        examination_no={audition.examination_info.examination_no}
                        examination_kbn={audition.examination_info.examination_kbn}
                        examination_s_no={audition.examination_info.examination_s_no}
                        result={audition.examination_info.result}
                      />
                    </div>
                    <div className="flex-1 h-full ml-4 max-w-[50%]">
                      <MessageSection userId={userId} auditionId={auditionId} />
                    </div>
                  </div>
                  <div className="sticky bottom-0 w-full flex justify-center items-center py-4 bg-[--c-background]">
                    <TransitionButton className="w-[10rem]" />
                  </div>
                </div>
              ))}
          </main>
          <AppFooter />
        </div>
      </div>
    </>
  );
};
